var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box } from "../../Box";
import { Icon } from "../../Icon";
export const Caret = (_a) => {
    var { "data-testid": dataTestId = "caret", direction } = _a, rest = __rest(_a, ["data-testid", "direction"]);
    const icon = {
        down: "CaretDown",
        right: "CaretRight",
        up: "CaretUp",
    }[direction];
    return (React.createElement(Box, Object.assign({}, rest),
        React.createElement(Icon, { "data-testid": dataTestId, src: icon, size: "8px" })));
};
